<label
  class="swap text-2xl hover:text-primary transition-all cursor-pointer hover:text-shadow-[0px_0px_10px_var(--color-primary)] swap-rotate">
  <!-- this hidden checkbox controls the state -->
  <input type="checkbox" [checked]="darkMode" (input)="toggleDarkMode()" />
  <!-- sun icon -->
  <ng-icon class="swap-off" name="solarMoonStarsBold" />
  <!-- moon icon -->
  <ng-icon class="swap-on" name="solarSun2Bold" />

</label>